import produce from 'immer';
import { combineReducers } from 'redux';
import { WorkspaceKeysActionType, WorkspaceKeysAction } from '../../actions/workspaceKeyActions';
import { WorkspaceKey } from '../../types/resources';

interface RuntimeState {
  byId: Record<string, WorkspaceKey>;
  allIds: string[];
}

export const initialState: RuntimeState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: WorkspaceKeysAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case WorkspaceKeysActionType.GET_WORKSPACE_KEYS:
        return {};
      case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_OK: {
        action.data.forEach((workspaceKey) => {
          draft[workspaceKey.id] = workspaceKey;
        });

        break;
      }
      case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS_OK: {
        return {};
      }
      case WorkspaceKeysActionType.GET_WORKSPACE_KEY_OK: {
        draft[action.keyId] = action.data;

        break;
      }
      case WorkspaceKeysActionType.EDIT_WORKSPACE_KEY_OK: {
        draft[action.keyId] = action.data;
        break;
      }
      case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case WorkspaceKeysActionType.DELETE_WORKSPACE_KEY_OK: {
        delete draft[action.data.id];
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: WorkspaceKeysAction) => {
  switch (action.type) {
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS:
      return [];
    case WorkspaceKeysActionType.GET_WORKSPACE_KEYS_OK:
      return action.data.map((workspaceKey) => workspaceKey.id);
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEYS_OK: {
      return [];
    }
    case WorkspaceKeysActionType.GET_WORKSPACE_KEY_OK: {
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    }
    case WorkspaceKeysActionType.CREATE_WORKSPACE_KEY_OK:
      return [action.data.id, ...state];
    case WorkspaceKeysActionType.DELETE_WORKSPACE_KEY_OK:
      return state.filter((id) => id !== action.keyId);
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
